import { get } from "lodash"

const seoTransformer = (contentItem) => (
  {
    title: get(contentItem, 'elements.seo__meta_title.value') || get(contentItem, 'elements.title.value'),
    description: get(contentItem, 'elements.seo__meta_description.value'),
    image: get(contentItem, 'elements.seo__seo_image.value[0].elements.image.value[0]'),
    imageAltText: get(contentItem, 'elements.seo__seo_image.value[0].elements.alt_text.value'),
  }
)

export default seoTransformer